

































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { IUser } from '../../store/profile/types';
import validator from 'validator';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({ components: { TwoFactorAuthInputPrompt } })
export default class VerifyEmail extends Mixins(AuthQuery) {
  @State(profile => profile.user, { namespace: 'profile' })
  readonly user!: IUser;

  @Getter('hasUsernamePasswordIdentity', { namespace: 'profile' })
  readonly hasUsernamePasswordIdentity!: boolean;

  @Prop(Function) readonly closeDialog!: () => void;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => any;

  editing = false;
  newEmailAddress = '';
  successSnackbar = false;
  updatedEmailSnackbarText = '';
  currentPassword = '';
  showCurrentPass = false;
  showPasswordSetupPrompt = false;

  get socialIdentityProvider() {
    const socialDictionary: { [key: string]: string } = {
      'google-oauth2': 'Google',
      apple: 'Apple',
      facebook: 'Facebook',
      discord: 'Discord',
    };
    const primaryIdProvider = this.user.auth0UserIdentities[0].connection;

    return this.hasUsernamePasswordIdentity
      ? ''
      : socialDictionary[primaryIdProvider];
  }

  validEmailAddress(val: string) {
    return (
      validator.isEmail(val) ||
      this.$t('components.settings.verifyEmail.enterValidAddressMsg')
    );
  }

  toggleEdit() {
    if (!this.hasUsernamePasswordIdentity) {
      this.showPasswordSetupPrompt = true;
      return;
    }
    this.editing = !this.editing;
  }

  goToPasswordSetup() {
    this.showPasswordSetupPrompt = false;
    this.$router.push('/account?component=ResetAccountPassword');
  }

  async handleSave() {
    await this.doAuthQuery(async totpToken => {
      const results = await this.updateUser({
        currentPassword: this.currentPassword,
        email: this.newEmailAddress,
        ignoreSnackbar: true,
        totpToken,
        rethrowErrorCodes: twoFaErrorCodes,
      });
      this.editing = false;
      if (results.success) {
        this.updatedEmailSnackbarText = this.$t(
          'components.settings.verifyEmail.successfulUpdateMsg',
          { newEmailAddress: this.newEmailAddress },
        ) as string;
        this.successSnackbar = true;
      }
      this.newEmailAddress = '';
    }, TwoFaCheckpoint.accountModifications);
  }
}
